import React from 'react'
import classNames from 'classnames'

import BodyCell from './BodyCell'
import { IBodyRow, onDoubleClick, onHoverPopup, onRowClassName, onRowHover } from './Types'
import { Timing } from '@cbgms/base/utils/timing'
import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

interface IBodyRowProps {
  row: IBodyRow
  onHover: onRowHover
  onHoverPopup?: onHoverPopup
  onDoubleClick: onDoubleClick
  onRowClassName?: onRowClassName
  rowHeight: number
  hovered: number | null
}

const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
    margin: 0
  }
}) as typeof Tooltip

function BodyRow(props: IBodyRowProps) {
  const { row, onHover, onDoubleClick, onRowClassName, rowHeight, hovered } = props
  const selectedRowClass = onRowClassName?.(row)
  const classes = classNames('cbgms-grid-row', selectedRowClass, {
    'cbgms-grid-row--hover': row.id === hovered
  })
  // check if customer is inactive
  const isCustomerInactive = row.data?.Customer?.CustStatus === 'Inactive'

  return (
    <NoMaxWidthTooltip
      arrow
      followCursor
      enterDelay={Timing.mediumAnimation}
      enterNextDelay={Timing.mediumAnimation}
      title={(props.onHoverPopup && props.onHoverPopup(row.data)) || ''}
    >
      <tr
        className={classes}
        onMouseEnter={() => onHover(row.id)}
        onMouseLeave={() => onHover(null)}
        onDoubleClick={() => onDoubleClick(row)}
        style={{
          height: rowHeight,
          maxHeight: rowHeight,
          backgroundColor: selectedRowClass ? '#c8c7c7dd' : isCustomerInactive ? '#f8d7da' : undefined,
          boxShadow: selectedRowClass ? 'inset 4px 0 0 #e8f5e90a' : undefined
        }}
      >
        {row.cols.map((col, i) => (
          <BodyCell key={i} cell={col} row={row} />
        ))}
      </tr>
    </NoMaxWidthTooltip>
  )
}

export default React.memo(BodyRow)
